import { CSSProperties, FunctionComponent, ReactNode } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { SmartTooltip } from '~/commonComponents';

interface IProps {
  Anchor: ReactNode;
  style?: Partial<{ container: CSSProperties }>;
}

export const ProfessionalBestInDentalWinnerTooltip: FunctionComponent<IProps> = ({
  Anchor,
  style,
}) => {
  return (
    <SmartTooltip
      content={
        <Typography as="span" bold color={colors.shades[0]}>
          This professional has earned GoTu’s Best in
          <br />
          Dental badge, our highest recognition for
          <br />
          reliability, professionalism, and excellence in
          <br />
          patient care.
        </Typography>
      }
      position="bottom"
      alignment="center"
      trigger="hover"
      style={{ Root: style?.container }}
    >
      {Anchor}
    </SmartTooltip>
  );
};
